import { cleanDisplayText, isTechnicalIdentifierLike } from './displayIdentifiers';

const RELATED_RECORD_ROUTES: Record<string, string> = {
  projects: '/projects',
  service_orders: '/service-maintenance',
  deals: '/deals',
  estimates: '/estimates',
  contacts: '/contacts',
  tasks: '/tasks',
  planning: '/planning',
  decisions: '/decisions',
  tradeshows: '/tradeshows',
  calendar_events: '/calendar',
  qbo_invoices: '/quickbooks/invoices',
};

const RELATED_RECORD_LABELS: Record<string, string> = {
  projects: 'Project',
  service_orders: 'Service Order',
  deals: 'Deal',
  estimates: 'Estimate',
  contacts: 'Contact',
  tasks: 'Task',
  planning: 'Planning',
  decisions: 'Decision',
  tradeshows: 'Tradeshow',
  calendar_events: 'Calendar Event',
  qbo_invoices: 'Invoice',
};

export type RelatedRecordNavigationTarget = {
  module: string;
  entity_id: string;
  display_id?: string | null;
  public_id?: string | null;
  formatted_id?: string | null;
};

function getPreferredRouteId(record: RelatedRecordNavigationTarget, fallbackEntityId?: string): string {
  const candidates = [
    record.display_id,
    record.public_id,
    record.formatted_id,
  ];

  for (const candidate of candidates) {
    const text = cleanDisplayText(candidate);
    if (text && !isTechnicalIdentifierLike(text)) {
      return text;
    }
  }

  return fallbackEntityId ?? record.entity_id;
}

export function getRelatedRecordPath(record: RelatedRecordNavigationTarget): string;
export function getRelatedRecordPath(module: string, entityId: string): string;
export function getRelatedRecordPath(
  recordOrModule: RelatedRecordNavigationTarget | string,
  entityId?: string,
): string {
  const record = typeof recordOrModule === 'string'
    ? { module: recordOrModule, entity_id: entityId || '' }
    : recordOrModule;
  const normalizedModule = record.module.trim();
  const basePath = RELATED_RECORD_ROUTES[normalizedModule] || `/${normalizedModule}`;
  return `${basePath}/${getPreferredRouteId(record, entityId)}`;
}

export function getRelatedRecordModuleLabel(module: string): string {
  const normalizedModule = module.trim();
  return RELATED_RECORD_LABELS[normalizedModule] || normalizedModule.replace(/[_-]+/g, ' ');
}
